export default {
    // Home page
    homeTotals: {},
    homeTop10Stalls: [],
    homeTop10Products: [],
    homeTop10Terminals: [],

    homeTotalsLoading: true,
    homeTopStallsLoading: true,
    homeTopProductsLoading: true,
    homeTopTerminalsLoading: true,

    // Takings page
    takingsTotalSales: {},
    takingsStallComparison: [],

    takingsTotalSalesLoading: true,
    takingsStallComparisonLoading: true,
    takingsJobProgress: "",

    // Product Sales page
    productSalesTotalTransactions: {},
    productSalesProducts: {},
    productSalesCategories: {},
    productSalesStallComparison: [],

    productSalesTotalTransactionsLoading: true,
    productSalesProductsLoading: true,
    productSalesCategoriesLoading: true,
    productSalesStallComparisonLoading: true,

    //transactions
    transactionsTransactions: [],
    transactionsLoading: false,
    transactionsLastEvaluatedKey: null,

    // Devices health
    devicesHealth: [],
    devicesHealthLoading: false,
  }